import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./nav-admin.css";
import UploadUsersIcon from "../../assets/images/svg-icons-material-io/group_add_FILL0_wght400_GRAD0_opsz48.svg";
import UploadStatusIcon from "../../assets/images/svg-icons-material-io/drive_folder_upload_FILL0_wght400_GRAD0_opsz48.svg";
import ReceivedMsgIcon from "../../assets/images/svg-icons-material-io/markunread_mailbox_FILL0_wght400_GRAD0_opsz48.svg";
import AddOrgCustomersIcon from "../../assets/images/svg-icons-material-io/domain_add_FILL0_wght400_GRAD0_opsz48.svg";
import { Link } from "react-router-dom";
import SubMenuModal from "./SubMenu/SubMenuModal";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";

const NavAdmin = () => {
  const navigate = useNavigate();
  const [flag, setFlag] = useState(false);
  const {
    isUserLogedIn,
    userRole,
    setCustomerObj,
    setCustomerFlag,
    setSearchObj,
    SetSharedObject,
    userSession,
  } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    setCustomerObj: state.setCustomerObj,
    setCustomerFlag: state.setCustomerFlag,
    setSearchObj: state.setSearchObj,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
  }));
  const [createUser, setCreateUser] = useState(false);
  useEffect(() => {
    if (flag) navigate(flag, { replace: true });
    setCreateUser(
      userSession?.CreateUserFlag || userRole === "SES ADMINISTRATOR"
    );
  }, [flag, navigate]);

  return (
    <div className="nav-admin">
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target=".navbar-collapse"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/*Admin Menus Begin*/}
      <div
        className="collapse navbar-collapse d-sm-inline-flex flex-sm-row-reverse"
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav nav-pills flex-grow">
          {/*Dashboard Menu*/}
          <li className="nav-item">
            <Link
              className="nav-link text-light"
              onClick={(el) => {
                setSearchObj([]);
                SetSharedObject("custumerRecord", {});
                setFlag("/dashboard");
              }}
            >
              <i
                className="bi bi-grid-3x3-gap sp-margin5"
                title="Dashboard"
              ></i>
              <span className="admin-nav1">Dashboard </span>
            </Link>
          </li>
          {/*Upload Menu*/}
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle text-light"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <i
                className="bi bi-box-arrow-in-up sp-margin5"
                title="Uploads"
              ></i>
              <span className="admin-nav1">Uploads</span>
            </a>
            <ul
              className="dropdown-menu submenu-upload-wrapper"
              aria-labelledby="navbarDropdown"
            >
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link to={"/upload-organization"} title="Upload Organizations">
                  <i
                    className="bi bi-building-up sp-margin5"
                    title="Upload Organizations"
                  ></i>
                  Organizations
                </Link>
              </li>
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link
                  to={"/upload-org-email"}
                  title="Upload Organization Emails"
                >
                  <i
                    className="bi bi-envelope sp-margin5"
                    title="Upload Organization Emails"
                  ></i>
                  Organization Emails
                </Link>
              </li>
              {createUser === true || userRole === "SES ADMINISTRATOR" ? (
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link to={"/user-upload"} title="Upload Users">
                    <img
                      className="filter-white sp-margin5 sp-margin5"
                      src={UploadUsersIcon}
                      alt="Upload Icon"
                      title="Upload Users"
                    />
                    Users
                  </Link>
                </li>
              ) : (
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link className="gray" title="Not Enabled" disabled>
                    <img
                      className="filter-gray sp-margin5 sp-margin5"
                      src={UploadUsersIcon}
                      alt="Upload Icon"
                      title="Upload Users"
                    />
                    Users
                  </Link>
                </li>
              )}
              {/*<li className="nav-item nav-link d-sm-inline-flex">*/}
              {/*  <Link to={"/upload-status"} title="Upload Organization Status">*/}
              {/*    <img className="filter-white sp-margin5 sp-margin5" src={UploadStatusIcon} alt="Upload Icon" title="Upload Organization Status" />*/}
              {/*    Upload Status*/}
              {/*  </Link>*/}
              {/*</li>*/}
            </ul>
          </li>
          {/*Organization Menu*/}
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle text-light"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <i
                className="bi bi-building sp-margin5"
                title="Manage Organizations"
              ></i>
              <span className="admin-nav1">Organizations</span>
            </a>
            <ul
              className="dropdown-menu submenu-org-wrapper"
              aria-labelledby="navbarDropdown"
            >
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link
                  onClick={(el) => {
                    setSearchObj([]);
                    SetSharedObject("UserIdEmail", {});
                    SetSharedObject("orgActionObj", false);
                    setFlag("/organizations");
                  }}
                  title="Search Organizations"
                >
                  <i
                    className="bi bi-search sp-margin5"
                    title="Search Organizations"
                  ></i>
                  Search
                </Link>
              </li>
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link
                  onClick={(el) => {
                    setCustomerObj({ Type: "sub", OrgType: "org" });
                      SetSharedObject("AddOrgFlag", true);
                    SetSharedObject("CustomerPermissionsObj", {
                      Type: "sub",
                      OrgType: "org",
                    });
                    setFlag("/organization-registration");
                  }}
                  title="Add Organization"
                >
                  <i
                    className="bi bi-building-add sp-margin5"
                    title="Add Organizations"
                  ></i>
                  Add
                </Link>
              </li>
            </ul>
          </li>
          {/*Users Menu*/}
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle text-light element"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <i className="bi bi-people sp-margin5" title="Manage Users"></i>
              <span className="admin-nav1"> Users</span>
            </a>
            <ul
              className="dropdown-menu submenu-users-wrapper"
              aria-labelledby="navbarDropdown"
              title="Users sub menus"
            >
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link
                  title="Search Users"
                  onClick={(el) => {
                    setSearchObj([]);
                    SetSharedObject("UserIdEmail", {});
                    setFlag("/users");
                  }}
                >
                  <i className="bi bi-search" title="Search Users"></i> Search
                </Link>
              </li>
              {createUser === true || userRole === "SES ADMINISTRATOR" ? (
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link
                    title="Add Users"
                    onClick={(el) => {
                      SetSharedObject("orgActionObj", {});
                      setFlag("/user-registration");
                    }}
                  >
                    <i className="bi bi-person-plus-fill"></i> Add
                  </Link>
                </li>
              ) : (
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link className="gray" title="Not Enabled" disabled>
                    <i className="bi bi-person-plus-fill"></i> Add
                  </Link>
                </li>
              )}

              {/*<li className="nav-item nav-link d-sm-inline-flex">*/}
              {/*  <Link to={"/upload-status"} title="Upload User Status">*/}
              {/*    <img className="filter-white sp-margin5" src={UploadStatusIcon} alt="Upload Icon" title="Upload User Status" />*/}
              {/*    Upload Status*/}
              {/*  </Link>*/}
              {/*</li>*/}
            </ul>
          </li>
          {/*Email Menu*/}
          <li className="nav-item">
            <Link
              className="nav-link text-light"
              onClick={(el) => {
                SetSharedObject("UserIdEmail", {});
                setFlag("/emails");
              }}
              title="Manage Emails"
            >
              <i
                className="bi bi-envelope sp-margin5"
                title="Manage Emails"
              ></i>
              <span className="admin-nav1">Emails</span>
            </Link>
          </li>
          {/*Reports*/}
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle text-light"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <i
                className="bi bi-journal-medical sp-margin5"
                title="Reports"
              ></i>
              <span className="admin-nav1">Reports</span>
            </a>
            <ul
              className="dropdown-menu submenu-reports-wrapper"
              aria-labelledby="navbarDropdown"
            >
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link
                  onClick={(el) => {
                    SetSharedObject("sentMessageStatusResults", {});
                    SetSharedObject("messageStatusSearch", {});
                    SetSharedObject("SentSearchType", "");
                    setFlag("/sent-message");
                  }}
                  title="Sent Message Report"
                >
                  <i
                    className="bi bi-send-check"
                    title="Sent Message Report"
                  ></i>{" "}
                  Sent Message
                </Link>
              </li>
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link
                  to={"/received-message"}
                  onClick={(el) => {
                    SetSharedObject("recievedMessageStatusResults", {});
                    SetSharedObject("messageStatusSearch", {});
                    SetSharedObject("SentSearchType", "");
                    setFlag("/received-messagee");
                  }}
                  title="Received Message Report"
                >
                  <img
                    src={ReceivedMsgIcon}
                    className="filter-white sp-margin5"
                    alt="Received Messages Icon"
                    title="Received Message Reports"
                  />
                  Received Message
                </Link>
              </li>
              <li className="nav-item nav-link d-sm-inline-flex">
                <a
                  href="#"
                  data-toggle="modal"
                  onClick={(el) => {
                    SetSharedObject("UserActiviySearch", {});
                    $("#UserReportSubMenu").modal("show");
                  }}
                  title="User Reports"
                >
                  <i className="bi bi-clipboard2-data" title="User Reports"></i>{" "}
                  User
                </a>
              </li>
              <li className="nav-item nav-link d-sm-inline-flex">
                <Link to={"/download-status"} title="Reports Download Status">
                  <i
                    className="bi bi-box-arrow-in-down"
                    title="Reports Download Status"
                  ></i>{" "}
                  Download Status
                </Link>
              </li>
            </ul>
          </li>

          {/*Documents*/}
          <li className="nav-item">
            <Link
              to={"/documents"}
              className="nav-link text-light"
              title="Manage Documents"
            >
              <i className="bi bi-files sp-margin5" title="Documents"></i>
              <span className="admin-nav1">Documents</span>
            </Link>
          </li>
          {/*Customers Menu*/}
          {userRole !== "SES ADMINISTRATOR" ? null : (
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle text-light"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="true"
              >
                <i
                  className="bi bi-globe2 sp-margin5"
                  title="Manage Customers"
                ></i>
                <span className="admin-nav1">Customers</span>
              </a>
              <ul
                className="dropdown-menu submenu-customers-wrapper"
                aria-labelledby="navbarDropdown"
              >
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link
                    onClick={(el) => {
                      SetSharedObject("CustomerObj", null);
                      SetSharedObject("refreshCustObj", true);
                      setFlag("/customers");
                    }}
                    title="Search Customers"
                  >
                    <i className="bi bi-search" title="Search Customers"></i>{" "}
                    Search
                  </Link>
                </li>
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link to={"/customer-registration"} title="Add Customers">
                    <i className="bi bi-plus-circle"></i> Add
                  </Link>
                </li>
                <li className="nav-item nav-link d-sm-inline-flex">
                  <Link
                    onClick={(el) => {
                      SetSharedObject("orgActionObj", {});
                      setCustomerObj({
                        Type: "top",
                        OrgType: "top",
                      });
                      SetSharedObject("CustomerPermissionsObj", {
                        Type: "top",
                        OrgType: "top",
                      });
                      setCustomerFlag(false);
                      SetSharedObject("AddOrgFlag", true);
                      setFlag("/toplevel-org-registration");
                    }}
                    title="Add Top Level Organization to Customer"
                  >
                    <img
                      src={AddOrgCustomersIcon}
                      className="filter-white sp-margin5"
                      title="Add Top Level Organization to Customer"
                    />
                    Add Top Level Organization to Customer
                  </Link>
                </li>
                {/*<li className="nav-item nav-link d-sm-inline-flex">*/}
                {/*    <Link to={"/user-upload"}>*/}
                {/*        <i className="bi bi-people"></i> Add Users to Org*/}
                {/*    </Link>*/}
                {/*</li>*/}
              </ul>
            </li>
          )}
        </ul>
      </div>
      <SubMenuModal />
    </div>
  );
};

NavAdmin.defaultProps = {};

export default NavAdmin;
